import { Component, Input } from '@angular/core';
import { UserContext } from '@core/models';
import { Clients } from '@shared/enums';
@Component({
  selector: 'sp-header',
  template: `
    <header #headerElement class="header">
      <sp-logo [client]="client" [userContext]="userContext"></sp-logo>
      <sp-nav-dropdown [userContext]="userContext"></sp-nav-dropdown>
      <sp-nav [userContext]="userContext"></sp-nav>
    </header>
  `,
  styleUrls: ['header.component.scss'],
})
export class HeaderComponent {
  isSticky = false;
  @Input() client: Clients;
  @Input() topNav: boolean;
  @Input() userContext: UserContext;
}
